module.exports = __webpack_public_path__ + "static/img/1.d3555d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/kmR22/1.jpg
// module id = oGxG
// module chunks = 1